import React from 'react';
import { observer } from 'mobx-react';
import Styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Build } from '@/assets/setting.svg';

function BuildPage() {
  const { t } = useTranslation();
  return (
    <div className={Styles.container}>
      <div className={Styles.context}>
        <Build width={288} height={216} />
        <div className={Styles.text}>{t('page_on_building')}</div>
      </div>
    </div>
  );
}

export default React.memo(observer(BuildPage));
